import axios from "axios";
import AuthStoreService from "@/helpers/authservice/auth-store-service";
import router from "@/router";
import "../main";
import Swal from "sweetalert2";
import app from "../main";
import config from "@/config/environment";

const authStoreService = new AuthStoreService();

const showError = (message, title = "Error!") => {
    Swal.fire({
        title: title,
        text: message,
        icon: "error",
        confirmButtonText: "OK",
    });
};

// Configure axios with environment settings
axios.defaults.baseURL = config.api.baseURL;
axios.defaults.timeout = config.api.timeout;
const responseCache = {};

axios.interceptors.request.use(
    (config) => {
        app.$Progress.start();
        const token = localStorage.getItem("token");
        if (token) {
            if (!config.headers) {
                config.headers = {};
            }
            config.headers[
                "Authorization"
            ] = `Bearer ${authStoreService.getToken()}`;
        }
        const endpoint = config.url;
        if (!responseCache[endpoint]) {
            app.$Progress.start();
            responseCache[endpoint] = {
                isResponsePending: true,
            };
            return config;
        } else if (responseCache[endpoint].isResponsePending) {
            return false;
        } else {
            app.$Progress.start();
            responseCache[endpoint].isResponsePending = true;
            return config;
        }
        //return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    (response) => {
        const endpoint = response.config.url;
        responseCache[endpoint].isResponsePending = false;
        delete responseCache[endpoint];
        if (response.status === 200 || response.status === 201) {
            app.$Progress.finish();
            if (response.data.status == 2) {
                let error = response.data.errors;
                error = Array.isArray(error) ? error[0] : error;
                console.log("error", error);
                showError(error?.content, error?.title);
                return Promise.reject(response);
            } else {
                return Promise.resolve(response);
            }
        } else {
            console.log(response);
            app.$Progress.finish();
            return Promise.reject(response);
        }
    },
    (error) => {
        if (error.response) {
            const endpoint = error.response?.config?.url;
            responseCache[endpoint].isResponsePending = false;
            delete responseCache[endpoint];
        }

        if (error.response?.status) {
            if (error.response.config.url.includes("refreshtoken")) {
                authStoreService.logOut();
                window.location.href = "/";
            }
            const errors = Object.values(
                error?.response?.data?.data || {}
            ).flat();
            let errorMessage = error?.response?.data?.error?.message;
            switch (error.response?.status) {
                case 400:
                    if (errors.length !== 0) {
                        errorMessage = errors.join("<br/>");
                    }

                    showError(errorMessage || "Bad Request");

                    throw error.response;

                case 401:
                    if (error.response.config.url.includes("login")) {
                        showError(error.response.data);
                    } else {
                        authStoreService.logOut();
                        window.location.href = "/";
                    }

                    break;
                case 403:
                    router.replace({
                        path: "/",
                        query: { redirect: router.currentRoute.fullPath },
                    });
                    break;
                case 404:
                    alert("page not exist");
                     app.$Progress.finish();
                    return Promise.reject(error.response);
                case 502:
                    setTimeout(() => {
                        router.replace({
                            path: "/",
                            query: {
                                redirect: router.currentRoute.fullPath,
                            },
                        });
                    }, 1000);
            }
            app.$Progress.finish();
            return Promise.reject(error.response);
        }
    }
);

export default axios;
